import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

export abstract class AnalyticsService {
    constructor(protected _http: HttpClient) {}

    protected _sendEvent(event_type: string, content: any, event_source: 'web' | 'ios' | 'android' = 'web', timestamp: number = new Date().getTime()): Promise<any> {
        return this._http
            .post(`${environment.apiUrl}/analytics/event`, {
                event_type,
                event_source,
                timestamp,
                content,
            })
            .toPromise();
    }
}
